/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AssetsDataManagerObjectDetailViewEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const assetsDataManagerObjectDetailViewEntryPoint: EntryPoint<
	AssetsDataManagerObjectDetailViewEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsDataManagerObjectDetailViewEntryPointComponent>(
		/* webpackChunkName: "async-assets-data-manager-object-classes-page", jiraSpaEntry: "async-assets-data-manager-object-detail-view-page" */ './AssetsDataManagerObjectDetailViewPage.tsx',
	),
	getPreloadProps: () => ({}),
});
